import { createSelector } from "reselect";
import { formatDate, parseDate } from "../utils/date";

const miljogebyr = (state) => state.miljogebyr;

export const getGridTableRowData = createSelector(miljogebyr, (miljogebyr) => {
  return [
    [
      {
        name: "Registrert i HGK",
        value: formatDate(parseDate(miljogebyr.opprettetDato), "dateTime"),
        description: "",
      },
      {
        name: "Opprettet i Pocket Control",
        value: formatDate(parseDate(miljogebyr.ileggelsesdatoFra), "dateTime"),
        description: "",
      },
    ],
  ];
});


